import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  Injectable,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { rootReducer } from './store';
import { TranslateModule } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideNgxMask } from 'ngx-mask';
import { LayoutEffects } from './store/layouts/layout-effect';
import { provideEffects } from '@ngrx/effects';
import { ToastrModule } from 'ngx-toastr';
import { AuthInterceptor } from '@app/auth/auth.interceptor';
import { authFactory } from '@app/auth/auth.factory';
import { AuthService } from '@app/auth/auth.service';
import { TranslateInterceptor } from "@app/core/interceptors/translate.interceptor";
import { NgbDropdownConfig, NgbTooltipConfig } from "@ng-bootstrap/ng-bootstrap";
import { translateFactory } from '@modules/settings/translations/translate-factory';
import { LanguageService } from '@app/core/services/language.service';
import { StatusInterceptor } from '@app/core/interceptors/status.interceptor';
import { GeoapifyGeocoderAutocompleteModule } from '@geoapify/angular-geocoder-autocomplete';


@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    if (this.isDynamicImportError(error)) {
      if (confirm('Neue Version verfügbar. Seite öffnen?')) {
        window.location.reload();
      }
    } else {
      throw error;
    }
  }

  private isDynamicImportError(error: any): boolean {
    return error.message.includes('Failed to fetch dynamically imported module');
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideStore(rootReducer),
    provideEffects(LayoutEffects), // Register effects
    provideNgxMask(),
    importProvidersFrom(
      GeoapifyGeocoderAutocompleteModule.withConfig('2e31468dd1e74ff48edbf370970d8cd8'),
      TranslateModule.forRoot(),
      ToastrModule.forRoot({
        timeOut: 5000,
        extendedTimeOut: 5000,
        closeButton: true,
        enableHtml: true,
        positionClass: 'toast-top-right'
      }),
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TranslateInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: StatusInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: authFactory,
      deps: [AuthService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: translateFactory,
      deps: [LanguageService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (tooltipConfig: NgbTooltipConfig) => () => {
        tooltipConfig.container = 'body';
      },
      deps: [NgbTooltipConfig],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (droddownConfig: NgbDropdownConfig) => () => {
        droddownConfig.container = 'body';
      },
      deps: [NgbDropdownConfig],
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }
  ]
};
